import { PRODUCTION_API_ORIGIN } from '@hoedokloop/contracts';
import type { ApiTransport } from '@hoedokloop/platform-ports';

export function createApiTransport(channel: 'web' | 'ait'): ApiTransport {
  return {
    request: async (path, init) => {
      // Only product API paths may receive a capability token. Reject absolute,
      // protocol-relative and normalized escape paths before touching the network.
      const parsed = new URL(path, PRODUCTION_API_ORIGIN);
      if (
        !path.startsWith('/v1/') ||
        /[\\\s#]/u.test(path) ||
        parsed.origin !== PRODUCTION_API_ORIGIN ||
        !parsed.pathname.startsWith('/v1/')
      ) {
        throw new Error('Invalid product API path');
      }
      const headers = new Headers(init?.headers);
      headers.set('x-hoedokloop-channel', channel);
      return fetch(channel === 'ait' ? `${PRODUCTION_API_ORIGIN}${path}` : path, {
        ...init,
        headers,
        credentials: 'omit',
        redirect: 'error',
      });
    },
  };
}
